




























import {
  Vue,
  Component
} from "@/shared/vuepack";
import { BankCustodian } from "@/admin/types";
import moment from "moment";
import { formatCurrency } from "@/shared/currency";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";

@Component
export default class InvestmentFeeDisclaimer extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  investmentThresholdStore = useInvestmentThresholdStore();

  formatCurrency = formatCurrency;

  mounted (): void {
      this.investmentThresholdStore.loadInvestmentThresholds({});
  }

  get limitCopy (): string {
      const limit = formatCurrency(this.investmentThresholdStore.thresholdForMoneyTransfer);
      return "Only funds more than " + limit + " in your HSA cash balance may be invested.";
  }

  get showHsabNote (): boolean {
      return this.custodianSettingsStore.isHsaBankCustodian;
  }

  get isHsab () {
      return this.custodianSettingsStore.userHsaCustodian === BankCustodian.HsaBank;
  }
}
